import BasicCode from "!!raw-loader!./links/Basic.tsx";
import IconCode from "!!raw-loader!./links/Icon.tsx";
import OverflowCode from "!!raw-loader!./links/Overflow.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Basic from "./links/Basic";
import Icon from "./links/Icon";
import Overflow from "./links/Overflow";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Basic", BasicCode, Basic),
		paneComponent("Icon", IconCode, Icon),
		paneComponent("Overflow", OverflowCode, Overflow, "Be careful using Link within a Grid item as it does not allow enough space for focus styling."),
	];

	return (
		<Pane
			components={components}
			imports='import {Link} from "designSystem/index";'
			muiApi="link"
			muiComponent="links"
			{...props}
		/>
	);
};